import React from "react";
import { Title, Flex, Stack } from "@mantine/core";
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";
import colorsCustom from "../designTokens/colorsCustom";
import { WriterInfo } from "./WriterInfo/WriterInfo";
import { Menu, Button } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { IconDotsVertical } from "@tabler/icons-react";
import { ActionIcon } from "@mantine/core";
import { IconPencil, IconTrash } from "@tabler/icons-react";

const CollectionTitleSection = ({
  collection,
  isMobile,
  setModalOpen,
  handleDeleteCollection,
  isMe,
}) => {
  const { t } = useTranslation();
  return (
    <Stack gap={16} w={"100%"} align={"flex-start"}>
      <Title
        order={isMobile ? 3 : 1}
        ta={"left"}
        fw={800}
        ff={
          '"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif'
        }
        c={colorsCustom.ui.dark.bold}
      >
        {collection.title}
      </Title>
      <Flex
        direction={"column"}
        align={"flex-start"}
        gap={4}
        style={{
          position: "relative",
          width: "fit-content",
          maxWidth: "100%",
        }}
      >
        <Title
          order={isMobile ? 5 : 2}
          fw={300}
          ta={"left"}
          c={colorsCustom.ui.dark.bold}
        >
          {collection.description}
        </Title>
      </Flex>
      <WriterInfo
        profileImage={collection.profileImage} // 기존 필드 유지
        userID={collection.userID} // 🆕 신규 필드 추가
        username={collection.username}
        name={collection.name}
        size={isMobile ? "small" : "big"}
        enableDynamicAvatar={true} // 🆕 동적 아바타 활성화
      />
      {isMe && (
        <Menu>
          <Menu.Target>
            <ActionIcon size={"lg"} variant="subtle">
              <IconDotsVertical size={24} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={() => console.log("Modify clicked")} p={0}>
              <Button
                size={"lg"}
                variant="subtle"
                leftSection={<IconPencil />}
                style={{ width: "100%" }}
                onClick={() => setModalOpen(true)}
              >
                {t("myCollection.modify")}
              </Button>
            </Menu.Item>
            <Menu.Item onClick={() => console.log("Delete clicked")} p={0}>
              <Button
                size={"lg"}
                variant="subtle"
                color="desctructive"
                leftSection={<IconTrash />}
                style={{ width: "100%" }}
                onClick={() => handleDeleteCollection()}
              >
                {t("myCollection.delete")}
              </Button>
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}
    </Stack>
  );
};

export default CollectionTitleSection;
